import React from 'react';

class InstantQuote extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.prepareData = this.prepareData.bind(this);
    this.needCustomQuote = this.needCustomQuote.bind(this);
    this.askCustomQuote = this.askCustomQuote.bind(this);
  }

  onClick() {
    if (!vfIsValidForQuote()) {
      return;
    }
    if (this.needCustomQuote()) {
      this.askCustomQuote();
      return;
    }
    if (!this.props.onQuoteRequest) {
      return;
    }

    const authToken = document.getElementsByName('authenticity_token')[0].value;
    const variantId = document.getElementsByName('variant_id')[0].value;

    this.props.onQuoteRequest(
      this.prepareData(),
      authToken,
      variantId,
      this.props.parameters.product_quote_number,
    );
  }

  prepareData() {
    const options = {};
    const parameters = this.props.parameters;
    this.props.suppliers.forEach((s) => {
      options[s] = parameters;
    });
    return options;
  }

  /**
   * needCustomQuote is boolean value, if isnt defined return false.
   * Each product must define in a reducer based on current form data.
   */
  needCustomQuote() {
    return this.props.needCustomQuote !== undefined && this.props.needCustomQuote;
  }

  askCustomQuote() {
    this.props.onCustomQuoteAsk();
  }

  render() {
    return (
      <div className="mb-3 d-grid">
        <button
          type="button"
          className={this.props.className}
          onClick={this.onClick}>
          {this.props.label}
        </button>
      </div>
    );
  }
}

InstantQuote.defaultProps = {
  className: 'btn btn-main-action',
  label    : 'QUOTE',
};

export default InstantQuote;
